import React from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

/**
 * Column header with up/down sort arrows (visible on header hover or keyboard focus only).
 */
export function SupportSortableHeader({
  columnId,
  label,
  sortColumn,
  sortDirection,
  onSort,
}) {
  const active = sortColumn === columnId;
  return (
    <button
      type="button"
      className="support-sort-header"
      onClick={() => onSort(columnId)}
      aria-label={`Sort by ${label}${active ? `, ${sortDirection === "asc" ? "ascending" : "descending"}` : ""}`}
    >
      {label}
      <span className="support-sort-arrows" aria-hidden>
        <FaArrowUp
          className={
            active && sortDirection === "asc"
              ? "support-sort-arrow support-sort-arrow--active"
              : "support-sort-arrow"
          }
        />
        <FaArrowDown
          className={
            active && sortDirection === "desc"
              ? "support-sort-arrow support-sort-arrow--active"
              : "support-sort-arrow"
          }
        />
      </span>
    </button>
  );
}
